export default __webpack_public_path__ + "static/media/favicon.de7a259d.svg";